import {Request} from "../request.abstract";
import {AuditLogResponse} from "./api.models";
import {Observable} from "rxjs/Observable";

export class AuditsEndpoint extends Request {
    collection(
        page?: number,
        perPage?: number,
        from?: string,
        to?: string,
        events?: string[],
        companyId?: number,
        userId?: number,
        sort?: string,
        direction?: string
    ): Observable<AuditLogResponse> {
        return this.get('/v1/audits', this.createSearch({
            page: page,
            perPage: perPage,
            sort: sort,
            direction: direction,
            events: events,
            from: from,
            to: to,
            companyId: companyId,
            userId: userId
        }));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/audits/api.service.ts